import React, { ReactElement } from "react";
import Debug from "debug";
import VideoPlayer from "./VideoPlayer";
import { StreamState } from "../../types";

import "./StreamPlayer.scss";

const debug = Debug("broadcast:components:StreamPlayer");

export enum StreamPlayerType {
  VideoJs = "VideoJS",
  IVS = "IVS",
}

interface StreamPlayerProps {
  url: string;
  type: StreamPlayerType;
  onStreamStateChange: (state: StreamState) => void;
}

const StreamPlayer = (
  props: StreamPlayerProps
): ReactElement<StreamPlayerProps> => {
  const { url, type, onStreamStateChange } = props;
  debug("Stream Player url", url);
  return (
    <div className="video-player-container">
      <VideoPlayer
        url={url}
        onStreamStateChange={onStreamStateChange}
        showControls={type === StreamPlayerType.VideoJs}
      />
    </div>
  );
};

export default StreamPlayer;
